<app-ui-field [label]="placeholder()" [hideLabel]="hideLabel()" [inputId]="inputId">
  <hlm-combobox-multiple
    autoHighlight
    class="label-typeahead"
    [itemToString]="labelOptionToString"
    [value]="selectedLabels()"
    (searchChange)="onSearchChange($event)"
    (stateChanged)="onPanelStateChange($event)"
    (valueChange)="onSelectedOptionsChange($event)"
  >
    <hlm-combobox-chips class="w-full">
      <ng-template hlmComboboxValues let-values>
        @for (label of values; track label.id) {
          <hlm-combobox-chip
            class="max-w-full border-0 text-text-on-pastel"
            [value]="label"
            [removeLabel]="'Remove label ' + label.name"
            [style.backgroundColor]="label.color"
          >
            <span class="truncate">{{ label.name }}</span>
          </hlm-combobox-chip>
        }
      </ng-template>

      <input
        #labelInput
        hlmComboboxChipInput
        type="text"
        name="labelSearch"
        [id]="inputId"
        [placeholder]="selectedLabelIdsState().length ? 'Add another label' : 'Search or create a label'"
        autocomplete="off"
      />
    </hlm-combobox-chips>

    <hlm-combobox-content *hlmComboboxPortal>
      <hlm-combobox-empty>No matching labels</hlm-combobox-empty>
      <div hlmComboboxList>
        @for (label of filteredLabels(); track label.id) {
          <hlm-combobox-item class="gap-2.5" [value]="label">
            <span class="h-4 w-4 shrink-0 rounded-full" [style.backgroundColor]="label.color" aria-hidden="true"></span>
            <span class="truncate text-left">{{ label.name }}</span>
          </hlm-combobox-item>
        }

        @if (canCreateLabel()) {
          <hlm-combobox-item class="gap-2.5 text-brand-primary-strong" [value]="createLabelOption()">
            <span class="italic">Create</span>
            <span class="truncate text-left">"{{ currentLabelText() | lowercase }}"</span>
          </hlm-combobox-item>
        }
      </div>
    </hlm-combobox-content>
  </hlm-combobox-multiple>
</app-ui-field>
